import { atom } from 'recoil';

export const themeData = atom ({
    key: "themeData",
    default:{},
})

export const iconsData = atom({
    key: 'iconsData',
    default: {},
});

export const iconsLoaded = atom({
    key: "iconsLoaded",
    default: false,
});